import React, { useState, useEffect } from "react";
import { BorderedNumberInput } from "../../../../HouseStyle/Components/Inputs";

/**
 * ShippingInfoBox Component
 * 
 * This component displays a box for adding shipping information (weight and dimensions)
 * to products. It only appears when the ProductWeightAndSize app is installed.
 * 
 * Props:
 * - product: The product object
 * - setProduct: Function to update the product object
 * - setUpdatedProduct: Function to mark product as updated
 */
const ShippingInfoBox = ({ product, setProduct, setUpdatedProduct }) => {
    const [weight, setWeight] = useState(product?.weight?.toString() || "");
    const [length, setLength] = useState(product?.length?.toString() || "");
    const [width, setWidth] = useState(product?.width?.toString() || "");
    const [height, setHeight] = useState(product?.height?.toString() || "");

    // Update parent component when values change
    useEffect(() => {
        if (product) {
            setWeight(product.weight?.toString() || "");
            setLength(product.length?.toString() || "");
            setWidth(product.width?.toString() || "");
            setHeight(product.height?.toString() || "");
        }
    }, [product?.product_id]);

    const handleWeightChange = (value) => {
        setWeight(value);
        setProduct({
            ...product,
            weight: value || null
        });
    };

    const handleLengthChange = (value) => {
        setLength(value);
        setProduct({
            ...product,
            length: value || null
        });
    };

    const handleWidthChange = (value) => {
        setWidth(value);
        setProduct({
            ...product,
            width: value || null
        });
    };

    const handleHeightChange = (value) => {
        setHeight(value);
        setProduct({
            ...product,
            height: value || null
        });
    };

    return (
        <div className="whiteBox p-5 h-100">
            <div className="d-flex flex-column">
                <h5 className="inputTitle mb-4">
                    Verzend informatie
                </h5>

                <div className="row g-3 mb-3">
                    <div className="col-12 col-md-6 col-lg-3">
                        <BorderedNumberInput
                            label="Gewicht (kg)"
                            inputValue={weight}
                            setInputValue={handleWeightChange}
                            placeholder="0,00"
                            decimal={true}
                            updateFunction={() => setUpdatedProduct(true)}
                            updateWaitTimer={1000}
                        />
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                        <BorderedNumberInput
                            label="Lengte (cm)"
                            inputValue={length}
                            setInputValue={handleLengthChange}
                            placeholder="0,00"
                            decimal={true}
                            updateFunction={() => setUpdatedProduct(true)}
                            updateWaitTimer={1000}
                        />
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                        <BorderedNumberInput
                            label="Breedte (cm)"
                            inputValue={width}
                            setInputValue={handleWidthChange}
                            placeholder="0,00"
                            decimal={true}
                            updateFunction={() => setUpdatedProduct(true)}
                            updateWaitTimer={1000}
                        />
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                        <BorderedNumberInput
                            label="Hoogte (cm)"
                            inputValue={height}
                            setInputValue={handleHeightChange}
                            placeholder="0,00"
                            decimal={true}
                            updateFunction={() => setUpdatedProduct(true)}
                            updateWaitTimer={1000}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShippingInfoBox;